export default __webpack_public_path__ + "static/media/img5.f9a33237.png";